var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card, CardBody, Link } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect, useRef, useState } from 'react';
import { GetOrderDetailsAPI } from '../../../api/oms/order-details';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { retrieveTrackingNumber, routeBuilder } from '../../../utils/general';
import { pushOrderDetailsOrderCardEvent } from '../../../utils/purchase-history/analytics';
import { getSelectedOrderDetail } from '../../../utils/purchase-history';
import { separateReturnedFG } from '../../../utils/returns/returns-fg-helper';
import { PHOrderDetailsAndActions } from '../delivery-tracker/PHOrderDetailsAndActions';
import { CardHeader } from './CardHeader';
import { CardMain } from './CardMain';
import { PHCardDetailSkeleton } from './CardSkeletonLoader';
import './PHCard.scss';
var getOrderType = function (orderNumber) {
    if (orderNumber && (orderNumber[0] === 'W' || orderNumber[0] === 'C')) {
        return 'ONLINE';
    }
    return 'INSTORE';
};
var generateOrderDetailsRequest = function (order, customerType, svocID) {
    var transactionType = order.transactionType, transactionId = order.transactionId, registerNumber = order.registerNumber, salesDate = order.salesDate, storeNumber = order.storeNumber, orderNumber = order.orderNumber, orderNumbers = order.orderNumbers;
    var filteredOrderNumber = orderNumber !== null && orderNumber !== void 0 ? orderNumber : orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0];
    var orderType = getOrderType(filteredOrderNumber);
    if (customerType === 'b2b' && orderType === 'ONLINE') {
        if (transactionType === 'R') {
            return {
                orderDetailsRequest: {
                    searchType: 'online',
                    registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                    salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                    storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                    transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                    transactionType: transactionType !== null && transactionType !== void 0 ? transactionType : '',
                    orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                    customerAccountId: svocID,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                },
            };
        }
        return {
            orderDetailsRequest: {
                searchType: 'online',
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: svocID,
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
            },
        };
    }
    if (orderType === 'INSTORE') {
        return {
            orderDetailsRequest: {
                searchType: 'instore',
                registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
                customerAccountId: svocID,
                groupAndSortBy: {
                    groupBy: 'fulfillmentType',
                    filterResponse: true,
                },
            },
        };
    }
    return {
        orderDetailsRequest: {
            searchType: orderType === null || orderType === void 0 ? void 0 : orderType.toLowerCase(),
            orderNumber: filteredOrderNumber !== null && filteredOrderNumber !== void 0 ? filteredOrderNumber : '',
        },
    };
};
export var orderDetailView = function (orderDetails, orderDetailsLoaded, record, customerType) {
    var _a, _b, _c, _d, _e;
    var enableNewDeliveryTracker = FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.useTrackerAlignedUX;
    if (!orderDetailsLoaded) {
        return (React.createElement(React.Fragment, null,
            React.createElement(PHCardDetailSkeleton, { numberOfSkeletons: 1 })));
    }
    if (orderDetails) {
        var _f = separateReturnedFG(orderDetails.fulfillmentGroups), orderedGroups = _f.orderedGroups, filteredGroups_1 = _f.filteredGroups, firstInitializedReturnIndex_1 = _f.firstInitializedReturnIndex;
        var orderType_1 = getOrderType((_a = record === null || record === void 0 ? void 0 : record.orderNumber) !== null && _a !== void 0 ? _a : (_b = record === null || record === void 0 ? void 0 : record.orderNumbers) === null || _b === void 0 ? void 0 : _b[0]);
        var orderNumber_1 = (_e = (_c = record === null || record === void 0 ? void 0 : record.orderNumber) !== null && _c !== void 0 ? _c : (_d = record === null || record === void 0 ? void 0 : record.orderNumbers) === null || _d === void 0 ? void 0 : _d[0]) !== null && _e !== void 0 ? _e : '';
        return (React.createElement("div", null, orderedGroups === null || orderedGroups === void 0 ? void 0 : orderedGroups.map(function (fg, indexFG) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var multipleQuantity = (_a = fg === null || fg === void 0 ? void 0 : fg.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (lItem) { var _a; return ((_a = lItem === null || lItem === void 0 ? void 0 : lItem.currentQuantity) !== null && _a !== void 0 ? _a : 0) > 1; });
            if (enableNewDeliveryTracker) {
                return (React.createElement("div", { className: "".concat(indexFG > 0 ? 'sui-mt-8' : '') },
                    React.createElement(PHOrderDetailsAndActions, { deliveryDataLoaded: orderDetailsLoaded, emailId: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.emailId, fulfillmentGroup: fg, net: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.net) || '', orderNumber: orderNumber_1, salesDate: record === null || record === void 0 ? void 0 : record.salesDate, variant: "card" })));
            }
            if (((_e = (_d = (_c = (_b = fg === null || fg === void 0 ? void 0 : fg.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.shipments) === null || _c === void 0 ? void 0 : _c.shipment) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 1 &&
                multipleQuantity !== undefined) {
                return (_h = (_g = (_f = fg === null || fg === void 0 ? void 0 : fg.shippingAndHandling) === null || _f === void 0 ? void 0 : _f.shipments) === null || _g === void 0 ? void 0 : _g.shipment) === null || _h === void 0 ? void 0 : _h.map(function (shipment, shipmentIndex) {
                    return (React.createElement(CardMain, { customerType: customerType, emailId: orderDetails.emailId, fg: fg, filteredGroups: filteredGroups_1, firstInitializedReturnIndex: firstInitializedReturnIndex_1 !== null && firstInitializedReturnIndex_1 !== void 0 ? firstInitializedReturnIndex_1 : 0, indexFG: indexFG, key: shipmentIndex, net: orderDetails.net || '', orderNumber: orderNumber_1, orderType: orderType_1, record: record, shipmentIndex: shipmentIndex, trackingNumber: retrieveTrackingNumber([shipment]) }));
                });
            }
            return (React.createElement(CardMain, { customerType: customerType, emailId: orderDetails.emailId, fg: fg, filteredGroups: filteredGroups_1, firstInitializedReturnIndex: firstInitializedReturnIndex_1 !== null && firstInitializedReturnIndex_1 !== void 0 ? firstInitializedReturnIndex_1 : 0, indexFG: indexFG, key: indexFG, net: orderDetails.net || '', orderNumber: orderNumber_1, orderType: orderType_1, record: record, trackingNumber: retrieveTrackingNumber((_l = (_k = (_j = fg === null || fg === void 0 ? void 0 : fg.shippingAndHandling) === null || _j === void 0 ? void 0 : _j.shipments) === null || _k === void 0 ? void 0 : _k.shipment) !== null && _l !== void 0 ? _l : []) }));
        })));
    }
    return null;
};
export var PHCard = function (_a) {
    var customerRole = _a.customerRole, customerType = _a.customerType, record = _a.record, index = _a.index;
    var _b = usePurchaseHistoryContext(), allOrderDetails = _b.allOrderDetails, setAllOrderDetails = _b.setAllOrderDetails;
    // TODO - needs to be used or removed. i.e. any error handling UI, etc.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _c = useState(null), orderDetailsError = _c[0], setOrderDetailsError = _c[1];
    var _d = useState(false), orderDetailsLoaded = _d[0], setOrderDetailsLoaded = _d[1];
    var sentinelRef = useRef(null);
    var svocID = useThdCustomer().svocID;
    var registerNumber = record.registerNumber, transactionId = record.transactionId, orderNumber = record.orderNumber, orderNumbers = record.orderNumbers, POJobName = record.POJobName, receiptDetails = record.receiptDetails, returnTotal = record.returnTotal, invoiceNumbers = record.invoiceNumbers, salesDate = record.salesDate, totalAmount = record.totalAmount;
    var selectedOrderDetail = getSelectedOrderDetail(allOrderDetails, orderNumbers, orderNumber, receiptDetails);
    useEffect(function () {
        if (selectedOrderDetail) {
            setOrderDetailsLoaded(true);
        }
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            if (entry.isIntersecting &&
                !orderDetailsLoaded &&
                !selectedOrderDetail) {
                GetOrderDetailsAPI(customerType, customerRole || '', generateOrderDetailsRequest(record, customerType, svocID))
                    .then(function (response) {
                    var orderDetails = response.data;
                    setAllOrderDetails(function (prevDetails) { return __spreadArray(__spreadArray([], prevDetails, true), [
                        orderDetails,
                    ], false); });
                })
                    .catch(function (error) {
                    setOrderDetailsError(error);
                })
                    .finally(function () {
                    setOrderDetailsLoaded(true);
                });
            }
        }, { rootMargin: '0px 0px 100% 0px', threshold: 1 });
        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }
        return function () {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
        };
    }, [orderDetailsLoaded]);
    var orderDetailsLink = "/myaccount/order-details".concat(routeBuilder(__assign({ index: index }, record)));
    var handleCardClick = function () {
        pushOrderDetailsOrderCardEvent();
    };
    return (React.createElement("div", { className: "sui-mb-[24px] card-edits" },
        React.createElement("div", { ref: sentinelRef, "data-testid": "sentinel-ref" }),
        React.createElement(Link, { href: orderDetailsLink },
            React.createElement(Card, { className: "sui-shadow-none sui-border-[rgb(204, 204, 203)] sui-rounded-sm", onClick: handleCardClick },
                React.createElement(CardHeader, { invoiceNumber: invoiceNumbers, isRefund: (returnTotal !== null && returnTotal !== void 0 ? returnTotal : 0) > 0, orderNumber: (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || orderNumber || receiptDetails, POJobName: POJobName || '', registerNumber: registerNumber, salesDate: salesDate, totalAmount: totalAmount, transactionId: transactionId }),
                React.createElement(CardBody, null,
                    React.createElement("div", null, orderDetailView(selectedOrderDetail, orderDetailsLoaded, record, customerType)))))));
};
